export function asyncAction(actionFn: () => any, title?: string) {
    return Promise.resolve()
        .then(() => actionFn())
        .then((data) => {
            if (title) {
                // todo
            }
            return data;
        })
        .catch((err) => {
            return Promise.reject(err);
        });
}
